var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBMCnt7RightLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 321,
    viewBox: "0 0 259 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175 98.1172C195 65.1172 249 52.1172 259.5 0.117188V320.117H0C57 302.617 115.857 273.617 145.5 232.117C165.5 204.117 139.5 156.692 175 98.1172Z",
    fill: "url(#paint0_linear_1341_31056)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.5 204.617C166 165.617 251.5 137.117 259.5 89.1172V320.117H103C143 294.617 116.352 255.676 144.5 204.617Z",
    fill: "url(#paint1_linear_1341_31056)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M179 218.117C206 179.117 246 186.617 259 121.617V320.117L113 322.617C155 312.117 156.5 250.617 179 218.117Z",
    fill: "url(#paint2_linear_1341_31056)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M259.243 320.617V204.117C240.5 240.117 215.133 231.76 192.5 260.617C172.5 286.117 176 306.617 185 320.617H259.243Z",
    fill: "url(#paint3_linear_1341_31056)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M259.001 321.117V240.117C247.501 259.117 222.273 276.439 214.876 287.82C206.313 300.995 209.001 318.617 219.001 321.117H259.001Z",
    fill: "url(#paint4_linear_1341_31056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1341_31056",
    x1: 129.336,
    y1: -153.703,
    x2: 193.228,
    y2: 281.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15778E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1341_31056",
    x1: 181,
    y1: -21.9214,
    x2: 235.707,
    y2: 289.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15778E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1341_31056",
    x1: 194.796,
    y1: 58.0357,
    x2: 234.211,
    y2: 297.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15778E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1341_31056",
    x1: 221,
    y1: 148.117,
    x2: 249.5,
    y2: 304.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15778E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1341_31056",
    x1: 232.416,
    y1: 201.182,
    x2: 252.235,
    y2: 309.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15778E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMCnt7RightLines);
export default __webpack_public_path__ + "static/media/b_m_cnt7_right_lines.19bdf4ff606f1ad567bf580bed745b12.svg";
export { ForwardRef as ReactComponent };